module.exports = __webpack_public_path__ + "static/Waves.1e1e6a60.png";